import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

export interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmDisabled?: boolean;
  overlayClassName?: string;
  tone?: 'warning' | 'danger' | 'neutral';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = 'Confirmar exclusão',
  message,
  confirmLabel = 'Excluir',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  confirmDisabled = false,
  tone = 'warning',
}) => {
  const badgeLabel = tone === 'danger' ? 'Excluir' : tone === 'neutral' ? 'Confirmar' : 'Atenção';
  const badgeColor: 'error' | 'info' | 'warning' =
    tone === 'danger' ? 'error' : tone === 'neutral' ? 'info' : 'warning';
  const confirmColor: 'error' | 'primary' = tone === 'danger' ? 'error' : 'primary';

  return (
    <Dialog
      open={isOpen}
      onClose={confirmDisabled ? undefined : onCancel}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-message"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="confirm-modal-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Chip label={badgeLabel} color={badgeColor} size="small" />
          <Box component="span" sx={{ fontWeight: 700 }}>
            {title}
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-modal-message" sx={{ color: 'text.primary' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button variant="outlined" onClick={onCancel} disabled={confirmDisabled}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={onConfirm}
          disabled={confirmDisabled}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
